// extracted by mini-css-extract-plugin
export default {"container":"Downloads_container__Tr04G","rotate180":"Downloads_rotate180__lHbuC"};